import styled, { css } from 'styled-components';
import Icon from '../Icon';

export const Container = styled.button(
  ({ theme }) => css`
    position: fixed;
    bottom: ${theme.sz.s10};
    right: ${theme.sz.s4};
    z-index: ${theme.zi.modal};
    transform: rotate(90deg);
    background-color: ${theme.co.neutral99};
    border: 0;
    border-radius: ${theme.bo.round};
    box-shadow: ${theme.sz.s0} ${theme.sz.s05} ${theme.sz.s2} rgba(0, 0, 0, 0.2);
    padding: ${theme.sz.s3};
    cursor: pointer;
    &:hover {
      background-color: ${theme.co.neutral98};
    }
  `,
);

export const ArrowIcon = styled(Icon)(
  ({ theme }) => css`
    font-size: ${theme.sz.s6};
  `,
);
